import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../hooks/useAuth';
import { varinymAPI } from '../lib/varinym-api';
import { PlanComparisonCard } from '../components/billing/PlanComparisonCard';
import type { PaddleBillingCycle } from '../types';

export function Plans() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const { data: subscription, isLoading } = useQuery({
    queryKey: ['billing', 'subscription'],
    queryFn: () => varinymAPI.getSubscription(),
    enabled: !!user,
  });

  const cycleParam = searchParams.get('cycle');
  const selectedCycle: PaddleBillingCycle =
    cycleParam === 'annual' ? 'annual' : cycleParam === 'monthly' ? 'monthly' : subscription?.billing_cycle ?? 'monthly';

  const handleCycleChange = (cycle: PaddleBillingCycle) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set('cycle', cycle);
        return next;
      },
      { replace: true }
    );
  };

  const handleUpgradeSuccess = () => {
    navigate('/settings?tab=billing');
  };

  if (isLoading || !subscription) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Loading plans...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground mb-2">Plans & Pricing</h1>
        <p className="text-muted-foreground">
          Compare plans and choose the one that fits your team.
        </p>
      </div>

      <PlanComparisonCard
        currentTier={subscription.tier}
        currentCycle={subscription.billing_cycle}
        selectedCycle={selectedCycle}
        onCycleChange={handleCycleChange}
        userEmail={user?.email}
        onUpgradeSuccess={handleUpgradeSuccess}
      />
    </div>
  );
}
